// Color schemes for sci-fi/fantasy author website
// Uncomment one theme at a time

// Theme 1: Midnight Steel (Active)
// export const theme = {
//   primary: '#f1f5f9',
//   secondary: '#f59e0b', 
//   accent: '#f59e0b',
//   text: '#f1f5f9',
//   textLight: '#94a3b8',
//   background: '#0f172a',
//   backgroundLight: '#1e293b',
//   borderColor: '#334155',
//   shadow: '0 2px 10px rgba(0, 0, 0, 0.3)',
//   shadowHover: '0 4px 20px rgba(0, 0, 0, 0.4)',
// };

// Theme 2: Mystic Depths
// export const theme = {
//   primary: '#e0e7ff',
//   secondary: '#6366f1', 
//   accent: '#ec4899',
//   text: '#e0e7ff',
//   textLight: '#a5b4fc',
//   background: '#1e1b4b',
//   backgroundLight: '#312e81',
//   borderColor: '#4338ca',
//   shadow: '0 2px 10px rgba(0, 0, 0, 0.3)',
//   shadowHover: '0 4px 20px rgba(0, 0, 0, 0.4)',
// };

// Theme 3: Shadow Realm
export const theme = {
  primary: '#f3f4f6',
  secondary: '#9ca3af', 
  accent: '#dc2626',
  text: '#f3f4f6',
  textLight: '#9ca3af',
  textDark: '#1f2937',
  background: '#111827',
  backgroundLight: '#1f2937',
  borderColor: '#374151',
  shadow: '0 2px 10px rgba(0, 0, 0, 0.3)',
  shadowHover: '0 4px 20px rgba(0, 0, 0, 0.4)',
};

// Theme 4: Emerald Forest
// export const theme = {
//   primary: '#ecfdf5',
//   secondary: '#10b981', 
//   accent: '#d97706',
//   text: '#ecfdf5',
//   textLight: '#6ee7b7',
//   background: '#022c22',
//   backgroundLight: '#064e3b',
//   borderColor: '#065f46',
//   shadow: '0 2px 10px rgba(0, 0, 0, 0.3)',
//   shadowHover: '0 4px 20px rgba(0, 0, 0, 0.4)',
// };

// Theme 5: Cosmic Void
// export const theme = {
//   primary: '#fafaf9',
//   secondary: '#78716c', 
//   accent: '#a855f7',
//   text: '#fafaf9',
//   textLight: '#a8a29e',
//   background: '#0c0a09',
//   backgroundLight: '#1c1917',
//   borderColor: '#292524',
//   shadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
//   shadowHover: '0 4px 20px rgba(0, 0, 0, 0.6)',
// };